import { Box, Tab, Tabs } from "@mui/material";
import { useCallback, useState } from "react";

const FieldNotebookTab = ({ onChange, tabs, value }) => {
  const [internalValue, setInternalValue] = useState(0);
  const selectedValue = value ?? internalValue;

  const handleChange = useCallback(
    (event, newValue) => {
      if (value === undefined) {
        setInternalValue(newValue);
      }
      onChange?.(newValue, event);
    },
    [onChange, value],
  );
  return (
    <Box width="100%" display="flex" flexDirection="column" mb={4}>
      <Tabs
        value={selectedValue}
        onChange={handleChange}
        aria-label="field-notebook-tab"
        sx={{ "& .MuiTabs-indicator": { backgroundColor: "black" } }}
        variant="scrollable"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.fieldId}
            label={`${tab.fieldName} (${tab.notesForField})`}
            sx={{
              textTransform: "none",
              fontSize: "16px",
              fontWeight: "bold",
              "&.Mui-selected": {
                color: "black",
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default FieldNotebookTab;
